/** biome-ignore-all lint/complexity/noStaticOnlyClass: Stateless API wrapper, static methods are sufficient. */
import { apiClient } from '../../ApiClient';
import type { UtilRequestConfig } from '../../types';
import {
	type BffConversationActsParams,
	type BffConversationActsResponse,
	type BffConversationUserPersonasParams,
	type BffConversationUserPersonasResponse,
	ConversationActsPaginationType,
	type ConversationActsParams,
	type ConversationActsResponse
} from './types';

const BFF_CONVERSATION_ACTS_LIMIT = 20;

export class ConversationService {
	static getActs(
		params: ConversationActsParams,
		config?: UtilRequestConfig
	): Promise<ConversationActsResponse> {
		return apiClient.get('v1/conversations/acts', {
			paramsSerializer: { indexes: null },
			...config,
			params
		});
	}

	static getBffActs(
		params: BffConversationActsParams,
		config?: UtilRequestConfig
	): Promise<BffConversationActsResponse> {
		return apiClient.get('v1/bff/conversations/acts', {
			paramsSerializer: { indexes: null },
			...config,
			params: {
				...params,
				pagination_type: ConversationActsPaginationType.Cursor,
				limit: BFF_CONVERSATION_ACTS_LIMIT
			}
		});
	}

	static getBffUserPersonas(
		params: BffConversationUserPersonasParams,
		config?: UtilRequestConfig
	): Promise<BffConversationUserPersonasResponse> {
		return apiClient.get('v1/bff/conversations/user-personas', {
			paramsSerializer: { indexes: null },
			...config,
			params
		});
	}
}
